import { Pipe, PipeTransform } from '@angular/core';
import { Question } from '@features/opportunities/components/questionnaire-form/models/questionnaire';

@Pipe({
  name: 'showAdditionalInfo',
  pure: true
})
export class ShowAdditionalInfoPipe implements PipeTransform {
  transform(question: Question): boolean {
    return (
      question.answer != null && question.answer.additionalInformation != null
    );
  }
}
